import type { IconData } from '@stacksjs/iconify-core'

export const trendingContentSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M23.87 2.288c.717-.641 1.744-.978 2.838-.674c.843.235 1.664.58 2.442 1.035c3.158 1.847 7.465 4.824 10.997 8.954c3.54 4.14 6.355 9.506 6.355 16.074c0 6.426-2.553 11.215-6.754 14.35c-4.142 3.09-9.745 4.475-15.748 4.475s-11.606-1.385-15.748-4.475c-4.201-3.136-6.754-7.924-6.754-14.35c0-9.598 5.995-16.61 11.543-21.051c2.073-1.66 4.786-.36 5.532 1.736c.513 1.438 1.123 2.583 1.79 3.244c.053.052.112.076.21.063a.56.56 0 0 0 .36-.23c1.142-1.554 1.645-4.105 1.78-6.684c.049-.946.464-1.848 1.157-2.467m.857 21.044a1.64 1.64 0 0 0-1.454 0C21.302 24.3 16 27.39 16 32.6c0 4.418 3.582 6.4 8 6.4s8-1.982 8-6.4c0-5.21-5.302-8.3-7.273-9.268\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default trendingContentSolid
